<template>
  <div>
    <b-card class="mt-1">
      <b-row>
       
        <v-select class="col-2" v-model="form.tipoBusqueda" placeholder="Buscar por" :options="tipoBusquedaOpts"
          :reduce="option => option.value" label="text" />

        <v-select :disabled="!form.tipoBusqueda" v-model="form.tipoBusquedaQuery" @search="onSearch"
          :options="tipoBusquedaQueryOpts" placeholder="Buscar por nombres o apellidos" :reduce="option => option.value"
          label="text" class="col-4" />

        <flat-pickr class="form-control col-2 ml-1" v-model="form.fechaDesde" locale="es" placeholder="Desde" />

        <flat-pickr class="form-control col-2 ml-1" v-model="form.fechaHasta" locale="es" placeholder="Hasta" />
      </b-row>

      <b-row class="my-1">
        <v-select v-model="form.establecimiento" placeholder="Establecimiento" :options="establecimientoOpts" :disabled="true"
          :reduce="option => option.value" label="text" class="col-2" />
        <v-select v-model="form.tipoSeguro" :multiple="true" placeholder="Tipo seguro" :options="segurosSaludOpts"
          :reduce="option => option.codigo" label="text" class="col-3" />

        <v-select v-model="form.tipoCobertura" :multiple="true" placeholder="Tipo cobertura"
          :options="tipoCoberturaOpts" :reduce="option => option" label="text" class="col-2" />

        <v-select 
          id="especialidad" v-model="form.especialidad" placeholder="Especialidad" :options="especialidadesOpts"
          :reduce="option => option" label="text" :multiple="true" class="col-3" 
        />

        <v-select 
          id="pservicio" v-model="form.tipoServicio" placeholder="Tipo Servicio" :options="tipoServicioOpts"
          :reduce="option => option" label="text" :multiple="true" class="col-2" 
        />
      </b-row>

      <b-row class="mt-2">
        <b-col md="4">
          <b-button 
            :disabled="empezoDescarga" 
            variant="primary" 
            @click="generarArchivo"
          >
            <span style="color: white">
              <i class="fa fa-cog" aria-hidden="true" />
              Generar
            </span>
          </b-button>
        </b-col>
      </b-row>

    </b-card>


    <div>
      <PdfTableComponent />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import rutasrep from '@/assets/utils/rutas.json';
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import {
  loadEspecialidadesOpts,
  loadTipoSegurosOpts,
  loadTipoCoberturaOpts,
  loadTipoServiciosOpts,
  loadPacientesOpts,
  loadEstablecimientosOpts,
  loadDoctoresOpts,
} from "../helpers";
import { getCurrentDate } from "@/shared/helpers";
import { generarPdf, infoPdfsAGenerar } from "../services/archivosPdf";
import PdfTableComponent from "./PdfTableComponent.vue";
import { getEstablecimientoLS } from '../../../shared/helpers';





export default {
  name: "FormPdfGenerate",

  components: {
    vSelect,
    flatPickr,
    PdfTableComponent
  },

  created() {
    this.loadDataInitForm();
  },

  data() {
    return {
      empezoDescarga : false,
      form: {
        tipoBusqueda: null,
        tipoBusquedaQuery: null,
        fechaDesde: null,
        fechaHasta: null,
        establecimiento: null,
        tipoSeguro: [],
        tipoCobertura: [{ value: "*", text: "TODOS", codigo: "*" } ],
        especialidad: [{ value: "*", text: "TODOS", codigo: "*" }],
        tipoServicio: [{ value: "*", text: "TODOS", codigo: "*" }],
      },

      segurosSaludOpts: [],
      tipoCoberturaOpts: [],
      especialidadesOpts: [],
      tipoServicioOpts: [],
      establecimientoOpts: [],
      tipoBusquedaQueryOpts: [],
      tipoBusquedaOpts: [
        { text: "Doctor", value: 1 },
        { text: "Paciente", value: 2 },
        { text: "Todos Doctor", value: 3 },
        { text: "Todos Paciente", value: 4 }
      ]
    }
  },

  methods: {

    async loadDataInitForm() {
      this.segurosSaludOpts = await loadTipoSegurosOpts();
      this.tipoCoberturaOpts = await loadTipoCoberturaOpts();
      this.especialidadesOpts = await loadEspecialidadesOpts();
      this.tipoServicioOpts = await loadTipoServiciosOpts();
      this.establecimientoOpts = await loadEstablecimientosOpts();
      this.form.establecimiento = getEstablecimientoLS().id
    },



    async downloadPdfs(id) {
   
      const query = `
        query MyQuery($id : ID!, $nameuser : String) {
          generatePdfsArchivopdfs(
            idArchivoPdf : $id, 
            nameuser : $nameuser
          ) {
            pdfBase64List
            identificaciones
            nombres
          }
        }
      `;
      let nameuser = ''
      const user = JSON.parse(localStorage.getItem('usuario'))
      if(user){
        nameuser = user.username
      }
      let establecimiento = ''
      const detalleusuario = JSON.parse(localStorage.getItem('detalleusuario'))
      if(detalleusuario){
        establecimiento = detalleusuario.establecimiento?.Descripcion
      }

      const dataUser = nameuser + " - " + establecimiento;
      const variables = { id : id, nameuser : dataUser }
      try {
        const response = await axios.post(rutasrep.axiosrep + 'api', { query, variables }); 
      } catch (error) {
        console.log(error);
      }
    },
    

    async verificarDescargas(){
      const query = `
        query MyQuery {
          viewOthersDownloadsPdfConsolidado {
            id
            userDescargando
            establecimiento {
              Descripcion
            }
          }
        }
      `;

      try {
              
        const response = await axios.post(rutasrep.axiosrep + 'api', { query });
        const respuesta = response.data.data.viewOthersDownloadsPdfConsolidado
        if (respuesta && respuesta.length > 4) {

          this.$swal.fire({
            icon : "warning",
            text : `Por favor espere, actualmente se estan procesando mas de 4 descargas masivas simultaneamente..`
          });
            
          return true;
        } 
        
        return false;

      } catch (error) {
        console.log(error);
      }
    },




    async generarArchivo() {
      const isValidForm = this.validateForm();
      if (!isValidForm) return;

      const variables = this.mapVariables();

      //const hayDescargas = await this.verificarDescargas()
      //if (hayDescargas) return;

      this.empezoDescarga = true
      const responseInfo = await infoPdfsAGenerar(variables);

      if (responseInfo) {
        const result = await this.$swal.fire({
          title: '¿Deseas continuar?',
          html: `${responseInfo}`,
          icon: 'info',
          showCancelButton: true,  
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
          const response = await generarPdf(variables);

          if (!response.status === 'success') {
            console.log('no se pudo generar el pdf');
            return;
          }

          this.modalOk()

          if (response.data.data.crearArchivoPdf.archivopdf.id){
            await this.downloadPdfs(response.data.data.crearArchivoPdf.archivopdf.id)
          }

        } else {
          this.empezoDescarga = false
          return 
        }
      }
     
    },



    validateForm() {
      const errors = [];
      const { fechaDesde, fechaHasta, tipoSeguro, tipoCobertura, especialidad, tipoServicio } = this.form;

      if (fechaDesde === null)
        errors.push('Debe seleccionar la fecha desde');

      if (fechaHasta === null)
        errors.push('Debe seleccionar la fecha hasta');

      if (tipoSeguro.length === 0)
        errors.push('Debe seleccionar el tipo seguro');

      if (tipoCobertura.length === 0)
        errors.push('Debe seleccionar el tipo cobertura');

      if (especialidad.length === 0)
        errors.push('Debe seleccionar la especialidad');

      if (tipoServicio.length === 0)
        errors.push('Debe seleccionar el tipo servicio');

      if (errors.length === 0) return true;

      const mensajeError = errors.join(', ');

      this.$swal({
        title: "Error",
        text: mensajeError,
        icon: "error",
        confirmButtonColor: "#089599",
      });

      return false;
    },


    mapVariables() {

      const {
        tipoBusqueda, tipoBusquedaQuery, fechaDesde, fechaHasta,
        tipoSeguro, tipoCobertura, especialidad, tipoServicio, establecimiento
      } = this.form;

      const tipoSeguroMap = tipoSeguro.map(item => item).join(',');
      const tipoCoberturaMap = tipoCobertura.map(item => item.codigo).join(',');
      const especialidadMap = especialidad
        .map(item => (item.codigo ?? item.value ?? '').toString().trim())
        .filter(item => item !== '')
        .join(',');
      const tipoServicioMap = tipoServicio.map(item => item.value).join(',');

      return {
        idDoctor: tipoBusqueda === 1 ? tipoBusquedaQuery : "",
        idPaciente: tipoBusqueda === 2 ? tipoBusquedaQuery : "",
        establecimiento : establecimiento ? establecimiento : "",
        pacdoc: "0",
        fechaProceso: getCurrentDate(),
        tipoBusqueda,
        tipoBusquedaQuery,
        fechaDesde, fechaHasta,
        tipoSeguro: tipoSeguroMap,
        tipoCobertura: tipoCoberturaMap,
        especialidad: especialidadMap,
        tipoServicio: tipoServicioMap
      };
    },

   

    async onSearch(searchTerm) {
      if (searchTerm.length > 3) {
        if (this.form.tipoBusqueda === 1) {
          console.log("entra doctor")
          try {
            let optDoc = [];
            let doctores = await loadDoctoresOpts(searchTerm);
            console.log("docs", doctores)
            optDoc = doctores.map(doc => ({
              value: doc.id,
              text: `${doc.idPersona.primerApellido} ${doc.idPersona.primerNombre} (${doc.idPersona.identificacion})`,
              identificacion: doc.idPersona.identificacion
            }));
            this.tipoBusquedaQueryOpts = optDoc;
          } catch (error) {
            console.error("Error loading doctor options:", error);
          }
        }

        else if (this.form.tipoBusqueda === 2) {
          console.log("entra paciente")

          try {
            let optPac = [];
            let pacientes = await loadPacientesOpts(searchTerm);
            optPac = pacientes.map(paciente => ({
              value: paciente.id,
              text: `${paciente.persona.primerApellido} ${paciente.persona.primerNombre} (${paciente.persona.identificacion})`,
              identificacion: paciente.persona.identificacion
            }));
            this.tipoBusquedaQueryOpts = optPac;
          } catch (error) {
            console.error("Error loading patient options:", error);
          }
        }
      }
    },


    modalOk() {
      this.$swal({
        title: "Exito",
        text: "Usuario admin, el archivo pdf entra en proceso de generacion",
        icon: "success",
        confirmButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {

          this.$router.go(0);
        }
      });
    }

  },


}
</script>
